import { render, staticRenderFns } from "./requiredDocuments.vue?vue&type=template&id=3c3b5e33"
import script from "./requiredDocuments.vue?vue&type=script&lang=js"
export * from "./requiredDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports